export default __webpack_public_path__ + "static/Termination_agreement-0a277e67b4b7fcf7ca275451d1389986.pdf";